/**
 * The (i) that carries an explanation as hover text.
 *
 * Every explanatory sentence on a board used to sit as a paragraph: under a
 * title, under a hero figure, under a chart. Read once it is useful; read on
 * every visit it is clutter. It rides on this icon instead, as a focusable
 * button so the keyboard reaches it too. The text is the title AND the
 * accessible name, so a screen reader hears what a pointer sees.
 */
import { Info } from "lucide-react";
import { cn } from "@/lib/utils";

export function InfoHint({
  text,
  className,
  ...rest
}: { text: string; className?: string } & Record<`data-${string}`, boolean | string | undefined>) {
  return (
    <button
      type="button"
      data-info-hint
      {...rest}
      title={text}
      aria-label={text}
      className={cn(
        "inline-flex shrink-0 rounded-sm align-middle text-muted-foreground opacity-60 transition-opacity hover:opacity-100 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
    >
      <Info className="size-3.5" aria-hidden />
    </button>
  );
}
